function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M10.12 1.3l5.63 11.28A2.37 2.37 0 0113.63 16H2.37a2.37 2.37 0 01-2.12-3.42L5.88 1.3a2.37 2.37 0 014.24 0zM8 10.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM8 9c.55 0 1-.32 1-.71V4.7c0-.38-.45-.7-1-.7s-1 .32-1 .71V8.3c0 .39.45.71 1 .71z"
})));